<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.tar_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="tar_decode">
            <label class="weui-form-preview__label">{{
              customLabel.tar_decode || "需求单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_decode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_name">
            <label class="weui-form-preview__label">{{
              customLabel.de_name || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_custname">
            <label class="weui-form-preview__label">{{
              customLabel.de_custname || "需求来源"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_product_type">
            <label class="weui-form-preview__label">{{
              customLabel.de_product_type || "产品类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_product_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_emname">
            <label class="weui-form-preview__label">{{
              customLabel.de_emname || "需求人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_dpname">
            <label class="weui-form-preview__label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_dpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_project_classify">
            <label class="weui-form-preview__label">{{
              customLabel.tar_project_classify || "项目分类"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_project_classify
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_project_level">
            <label class="weui-form-preview__label">{{
              customLabel.tar_project_level || "项目等级"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_project_level
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_emname">
            <label class="weui-form-preview__label">{{
              customLabel.tar_emname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_budget">
            <label class="weui-form-preview__label">{{
              customLabel.tar_budget || "项目预算金额"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_budget
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_currency">
            <label class="weui-form-preview__label">{{
              customLabel.tar_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_currency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_function_match_degree">
            <label class="weui-form-preview__label">{{
              customLabel.tar_function_match_degree || "功能要求匹配度"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_function_match_degree
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_performance_conformity">
            <label class="weui-form-preview__label">{{
              customLabel.tar_performance_conformity || "性能要求符合度"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_performance_conformity
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_compatibility">
            <label class="weui-form-preview__label">{{
              customLabel.tar_compatibility || "兼容性"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_compatibility
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_team_capacity">
            <label class="weui-form-preview__label">{{
              customLabel.tar_team_capacity || "团队技术能力"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_team_capacity
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_technical_risk">
            <label class="weui-form-preview__label">{{
              customLabel.tar_technical_risk || "技术风险分析"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_technical_risk
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_develop_period">
            <label class="weui-form-preview__label">{{
              customLabel.tar_develop_period || "开发周期"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_develop_period
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="tar_feasibility_assess">
            <label class="weui-form-preview__label">{{
              customLabel.tar_feasibility_assess || "技术可行性评估结论"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.tar_feasibility_assess
            }}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.tar_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/technical_report_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary">编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/plm/technicalAnalyseReport",
      codeField: "tar_code",
      statusField: "tar_statuscode",
      caller: "TechnicalAnalyseReport",
      xtype: "plm-technicalanalysereport-formpanel",
    };
  },
};
</script>
